/**
 * Enumeration for dealer sales channel.
 *
 * @readonly
 * @enum {string}
 */
export const DealerSalesChannels = Object.freeze({
    DIRECT_SALES: 'DIRECT_SALES',
    RESELLER: 'RESELLER'
})
